import { RefObject, useEffect } from 'react';
import { InputArea } from '@wix/design-system';

// handle Japanese IME enter key press
export const useIMEEnter = (ref: RefObject<InputArea>) => {
  useEffect(() => {
    if (ref.current) {
      const textarea = (
        ref.current as InputArea & { textArea: HTMLTextAreaElement }
      ).textArea;

      textarea.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          if (event.isComposing) {
            event.stopPropagation();
          }
        }
      });
    }
  }, []);
};
